import { render, staticRenderFns } from "./Vault.vue?vue&type=template&id=1468b8f8&scoped=true&"
import script from "./Vault.vue?vue&type=script&lang=js&"
export * from "./Vault.vue?vue&type=script&lang=js&"
import style0 from "./Vault.vue?vue&type=style&index=0&id=1468b8f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1468b8f8",
  null
  
)

export default component.exports